module.exports = __webpack_public_path__ + "7ef04d06288eee6b7f90bf643d874e01.jpeg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/alt/report-img-big.jpeg
// module id = 722
// module chunks = 0